import { Card, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import AppConfig from "../../core/service/AppConfig";
import SystemLogViewer from "./viewer/SystemLogViewer";
import OnlineUsersPanel from "./online-users/OnlineUsersPanel";
import RouteStatsPanel from "./route-stats/RouteStatsPanel";

const TABS = ['logs', 'online', 'endpoints'];

export default function SystemLogApp() {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();

    // Aktif sekme URL'de tutulur: link paylaşılabilsin, detaydan geri dönüşte sekme korunsun.
    // ?route=... ile gelindiyse (Endpointler sekmesinden tıklama) log sekmesi açılır.
    const params = new URLSearchParams(location.search);
    const [tab, setTab] = useState(TABS.includes(params.get('tab')) ? params.get('tab') : 'logs');

    useEffect(() => {
        document.title = `${t('System Logs')} - ${AppConfig.getHisTitle()}`
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onTabChange = (key) => {
        setTab(key);
        history.replace(key === 'logs' ? location.pathname : `${location.pathname}?tab=${key}`);
    };

    // Endpointler sekmesinden bir endpoint'e tıklanınca: URL'e route filtresini koy ve log sekmesine geç.
    // Sıra önemli — viewer mount olduğunda ?route='i okuyacağı için önce URL yazılır.
    const openRouteLogs = (route) => {
        history.replace(`${location.pathname}?route=${encodeURIComponent(route)}`);
        setTab('logs');
    };

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('System Logs')}>
                <Tabs
                    activeKey={tab}
                    onChange={onTabChange}
                    // Kapalı sekme unmount edilir: Çevrimiçi panelinin 15 sn'lik tazeleme timer'ı arkada dönmesin.
                    destroyInactiveTabPane
                    items={[
                        {
                            key: 'logs',
                            label: t('System Logs'),
                            children: <SystemLogViewer />
                        },
                        {
                            key: 'online',
                            label: t('Online'),
                            children: <OnlineUsersPanel />
                        },
                        {
                            key: 'endpoints',
                            label: t('Endpoints'),
                            children: <RouteStatsPanel onOpenLogs={openRouteLogs} />
                        }
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
